<template>
    <div class="homeworkDetail">
        <div class="text-center oneLine topH">
            <div class="title">
                {{title}}
            </div>
            <div class="margin-top person  ">
                布置人：{{teacherName}}
            </div>
            <div class="margin-top time  ">
                {{startAt}}~{{deadlineAt}}
            </div>
        </div>
        <div class="secondLine">
            <div class="secondSon">
                <div class="delFloat">
                    <div class="float-left">
                       <span class="font-weight-bolder text-l-size">作业总进度</span>
                       <span class="text-medium-secondary text-m-size"> {{completeRatio}}%</span>
                    </div>
                    <div class="float-right text-m-size">
                        已完成 <span class="primary">{{completedItemCount}}</span>{{'/'+itemCount}}
                    </div>
                </div>
                <div class="margin-top">
                    <el-progress :percentage="completeRatio" :show-text="false" :color="customColors"></el-progress>
                </div>
                <div class="  numberColor">
                    总进度在完成作业后1小时更新，请耐心等待！
                </div>
            </div>
            <div class="commonBackground thirdSon">
                <div class="subjectLine margin-medium-y padding-left" v-show="subjectList.length>1" >
                    <el-button size="small" @click="selectSubject(item.subjectId)"
                               :class="subjectId===item.subjectId?'active':''"
                               class="text-default-color"
                               type="text" v-for="item in subjectList" :key="item.subjectId">
                        {{item.subjectName}}
                    </el-button>
                </div>
                <div class="delFloat box position-relative"
                     @click="getSelectSubjectHomeWorkAnswer(item)"
                     v-for="(item,index) in homeworkList" :key="index">
                    <div class="float-left delFloat">
                        <div class="imgBox margin-medium-right float-left">
                            <img v-lazy="item.coverImg" width="" src="" alt="">
                        </div>
                        <div class="title float-right">
                            <h1>
                                【{{item.subjectName}}】{{item.title}}
                            </h1>
                            <div class="text-medium-secondary">
                                （建议时长{{item.durationStr}}）
                            </div>
                        </div>
                    </div>
                    <div class="right position-absolute">
                        <el-progress type="circle" :class="item.completeRatio===100?'commit':''" :width="100"
                                     :color="customColors"
                                     :format="setItemText(item.completeRatio)"
                                     :percentage="item.completeRatio">
                        </el-progress>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        getReportId,
        getSelectSubjectHomeWorkAnswer,
        myHomeStuHwBaseInfo,
        myHomeStuHwItems,
        myHomeStuHwSubject
    } from "../../../config";
    import {EventBus} from "../../../assets/static/global/event-bus";
    export default {
        name: "homeworkDetail",
        data(){
            return{
                customColors:[
                    {color: '#f56c6c', percentage: 20},
                    {color: '#FFAD01', percentage: 60},
                    {color: '#52c41a', percentage: 100}
                ],
                hwId:'',
                subjectList:[],
                subjectId:'',
                title:'',
                startAt:'',
                deadlineAt:'',
                teacherName:'',
                //完成比率
                completeRatio:0,
                //已完成试题总数
                completedItemCount:'',
                //试题总数
                itemCount:'',
                homeworkList:[]
            }
        },
        mounted(){
            this.myHomeStuHwBaseInfo();
            EventBus.$emit('homeworkDetail','in')
        },
        beforeDestroy(){
            EventBus.$emit('homeworkDetail','')
        },
        methods:{
          //查出基本信息
          async myHomeStuHwBaseInfo(){
              this.hwId=this.$route.query.hwId;
              this.teacherName=this.$route.query.teacherName;
              this.startAt=this.$route.query.startAt;
              this.deadlineAt=this.$route.query.deadlineAt;
              let result=await myHomeStuHwBaseInfo(this.hwId);
              if(result.status){
                  this.title=result.data.title;
                  this.completeRatio=Math.ceil(result.data.completeRatio);
                  this.itemCount=result.data.itemCount;
                  this.completedItemCount=result.data.completedItemCount;
                  this.myHomeStuSubject();
              }
          },
          //查出当前作业所包含的学科
          async myHomeStuSubject(){
              let result=await myHomeStuHwSubject(this.hwId);
              if(result.status){
                  this.subjectList=result.data;
                  this.subjectId=this.subjectList[0].subjectId;
                  this.homeItems();
              }
          },
          selectSubject(val){
              this.subjectId=val;
              this.homeItems();
          },
          //根据条件查出作业内容所包含的作业条目
          async homeItems(){
              let result=await myHomeStuHwItems(this.hwId,this.subjectId);
              if(result.status){
                  this.homeworkList=result.data;
              }
          },
          // 自定义进度条文字
          setItemText(row) {
              return () => {
                  if(row===100){
                      return ` 已完成 `
                  }else{
                      return row+'%';
                  }
              }
          },
          //检查是否是试卷做完的或者未做完如果做完则挑转到结果页查出内容，否则跳转到做题页面
          async getReportId(resourceId,itemId){
             let result=await getReportId(resourceId,this.hwId);
             if(result.status){
                 if(result.data!==''&&result.data!==null){
                     this.$router.push({path:'/sDetail/answerResultPaper',
                         query:{itemId:itemId,paperCommitId:result.data}});
                 }else{
                     this.$router.push({path:'/sDetail/answersToTestPapers',query:{itemId:itemId,resourceId:resourceId}});
                 }
             }
          },
          //获取当前选科作业的完成状态
          async getSelectSubjectHomeWorkAnswer(item){
              if(item.typeId===1){
                  this.getReportId(item.resourceId,item.itemId);
                  return false;
              }else if(item.typeId===2){
                  this.$router.push(
                      {path:'/videoPlayer',
                          query:{albumId:item.albumId,
                              videoId:item.resourceId,
                              itemId:item.itemId}}
                  );
                  return false;
              }
            let result=await getSelectSubjectHomeWorkAnswer(item.itemId);
            if(result.status){
                if(!result.data.isCompleted){
                   if(item.typeId===3){
                        this.$router.push({path:'/electiveAnswer/index',
                            query:{itemId:item.itemId,resourceId:item.resourceId,typeId:item.typeId}});
                    }
                }else{
                    //若为true 完成作业结果页，做一个，如果
                    this.$router.push({path:'/resultPage/index',
                        query:{itemId:item.itemId,resourceId:item.resourceId,typeId:item.typeId}});
                }
            }
          }
        }
    }
</script>
<style lang="scss">
    .homeworkDetail{
        .commit{
            .el-progress__text{
                color:#52c41a!important;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .homeworkDetail{
        .topH{
            background: url("http://cdn.oasisedu.net/lvzpc/topPcHwBk.png") no-repeat;
            background-size: 100% 100%;
        }
        .active{
            color: #ffffff!important;
            padding: 5px 10px;
        }
        .oneLine {
            margin-top:10px;
            height: 220px;
            width: 100%;
            padding-top: 20px;
            color:#96a2be;
            .title {
                font-size: 30px;
                font-weight: bolder;
            }
            > div {
                font-size: 16px;
            }
        }
        .secondLine{
            width:1000px;
            margin:0 auto;
            .secondSon{
                position: relative;
                padding: 24px 30px;
                background: #fff;
                border-radius: 8px;
                margin-top: -40px;
                .float-right{
                    .primary{
                        color:dodgerblue;
                    }
                }
                .numberColor{
                    margin-top:10px;
                }
            }
            .thirdSon {
                border-radius: 8px;
                min-height: 600px;
                width: 1000px;
                margin: 30px auto 0 auto;
                padding: 10px;
                .box:hover{
                    box-shadow: 0 2px 8px rgb(105 124 239 / 26%);
                }
                .box{
                    display: flex;
                    padding: 20px;
                    margin: 10px 10px 0 10px;
                    cursor: pointer;
                    border-bottom: 1px solid #eaeaea;
                    .imgBox {
                        width: 160px;
                        height: 88px;
                        overflow: hidden;
                        background: blueviolet;
                        img{
                            width: 160px;
                            height: 88px;
                        }
                    }
                    .title{
                        h1{
                            font-size: 18px;
                        }
                    }
                }
                .right{
                    right:20px;
                    top:16px;
                }
            }
        }
    }
</style>